export default __webpack_public_path__ + "static/media/logo.f517f421.svg";